import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const foodLibraryService={
    addFoodLibrary,
    updateFoodLibrary,
    getAllFoodItems,
    deleteFoodItem,
    getAllFoodMeasureServices
}

function addFoodLibrary(request){
    return apiCall("POST",apiUrls.food.library,request)
}

function updateFoodLibrary(request,id){

    return apiCall("PUT",`${apiUrls.food.library}/${id}`,request)
}

function getAllFoodItems(params){

    return apiCall("GET",apiUrls.food.library,null,params)
}

function deleteFoodItem(id) {
    return apiCall("DELETE", `${apiUrls.food.library}/${id}`);
  }

  function getAllFoodMeasureServices(params){

    return apiCall("GET",apiUrls.food.foodMeasures,null,params)
}